import "chartjs-adapter-date-fns";
import {
  Chart as ChartJS,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import type { ChartDataset, ChartOptions } from "chart.js";
import tailwindColors from "tailwind.config/colors";

// Single registration for all analytics line charts — importing this module
// replaces the per-file ChartJS.register calls.
ChartJS.register(
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  TimeScale,
  Title,
  Tooltip
);

export const CHART_TICK_COLOR = tailwindColors.neutral["500"];
export const CHART_GRID_COLOR = tailwindColors.neutral["100"];

// Options shared by every analytics line chart. Spread this and extend;
// note `plugins` is replaced (not merged) if a chart redefines it.
export const BASE_LINE_CHART_OPTIONS: ChartOptions<"line"> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
  },
  interaction: { mode: "index", intersect: false },
};

type LineDatasetParams<TData> = {
  label: string;
  color: string;
  data: TData[];
} & Partial<ChartDataset<"line", TData[]>>;

// Default line-series styling; pass overrides for per-chart differences.
export function createLineDataset<TData>({
  label,
  color,
  data,
  ...overrides
}: LineDatasetParams<TData>): ChartDataset<"line", TData[]> {
  return {
    label,
    data,
    tension: 0.3,
    fill: false,
    pointRadius: 3,
    borderColor: color,
    backgroundColor: color,
    ...overrides,
  };
}
